import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { JobStatusDetail } from '../models/progress.model';

@Injectable({
  providedIn: 'root'
})
export class ProgressStateService {
  private readonly processSubject = new BehaviorSubject<JobStatusDetail[]>([]);
  private readonly isProgressOngoing = new BehaviorSubject<boolean>(false);
  private readonly isGroupUpload = new BehaviorSubject<boolean>(false);

  public setProgressState(state: boolean): void {
    this.isProgressOngoing.next(state);
  }

  public getProgressState(): Observable<boolean> {
    return this.isProgressOngoing.asObservable();
  }

  public setIsGroupUploadState(state: boolean): void {
    this.isGroupUpload.next(state);
  }

  public getIsGroupUploadState(): Observable<boolean> {
    return this.isGroupUpload.asObservable();
  }

  public setProcess(process: JobStatusDetail[]): void {
    this.processSubject.next(process);
  }

  public getProcess(): JobStatusDetail[] {
    return this.processSubject.value;
  }
}
